import { render, staticRenderFns } from "./Reback.vue?vue&type=template&id=79f72dc6&"
import script from "./Reback.vue?vue&type=script&lang=js&"
export * from "./Reback.vue?vue&type=script&lang=js&"
import style0 from "./Reback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports